import {Outlet, useOutletContext} from 'react-router-dom'
import {CompanyProvider} from 'src/contexts/CompanyContext'
import {AppSidebarProvider} from 'src/layouts/main-layout/app-sidebar/app-sidebar-context'
import {AppSidebar} from 'src/layouts/main-layout/app-sidebar/app-sidedbar'
import {CompaniesSelectorProvider} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {AppProvider} from './contexts/AppContext'
import {Header} from './header/Header'

type ChartEventFilterDate = {
  start: string
  end: string
}

type ContextType = {filterDate: ChartEventFilterDate}

function MainLayout() {
  return (
    <AppProvider>
      <CompaniesSelectorProvider>
        <AppSidebarProvider>
          <CompanyProvider>
            <div data-slot='app-layout' className='bg-background text-foreground grid min-h-dvh w-full grid-rows-[55px_1fr] h-[100vh] overflow-hidden'>
              <Header />
              <div data-slot='app-body' className='row-start-2 grid min-h-0 grid-cols-[auto_1fr]'>
                <AppSidebar />
                <main data-slot='app-main' className='min-w-0 p-2 bg-[#ebebeb] overflow-auto'>
                  <Outlet />
                </main>
              </div>
            </div>
          </CompanyProvider>
        </AppSidebarProvider>
      </CompaniesSelectorProvider>
    </AppProvider>
  )
}

export function useHeader() {
  return useOutletContext<ContextType>()
}

export default MainLayout
